import {
  ThemeNightIconComponent,
  ThemeSettingsIconComponent,
} from "assets/icons";
import Switch from "components/Switch";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  WEBAPP_THEME_MODE_DARK,
  WEBAPP_THEME_MODE_LIGHT,
} from "utils/constants";

const getAgent = ({ userData }) => userData.agent.data;

function ThemeSettings({ onThemeToggle }) {
  const [tmpTheme, setTmpTheme] = useState(WEBAPP_THEME_MODE_LIGHT); // default to "light" theme
  const agentData = useSelector(getAgent);

  function handleThemeChange() {
    const newTheme =
      tmpTheme === WEBAPP_THEME_MODE_LIGHT
        ? WEBAPP_THEME_MODE_DARK
        : WEBAPP_THEME_MODE_LIGHT;

    setTmpTheme(newTheme);
    document.querySelector("body").setAttribute("theme", newTheme);

    onThemeToggle(newTheme === WEBAPP_THEME_MODE_LIGHT ? "1" : "2");
  }

  useEffect(() => {
    const t =
      agentData?.appStyle === "2"
        ? WEBAPP_THEME_MODE_DARK
        : WEBAPP_THEME_MODE_LIGHT;

    setTmpTheme(t);
  }, [agentData?.appStyle]);

  return (
    <div className="theme-box">
      <div className="theme-box-icon-container" data-theme={tmpTheme}>
        {tmpTheme === WEBAPP_THEME_MODE_LIGHT ? (
          <ThemeSettingsIconComponent />
        ) : (
          <ThemeNightIconComponent />
        )}
      </div>

      <Switch
        onChange={handleThemeChange}
        checked={tmpTheme === WEBAPP_THEME_MODE_DARK}
      />
    </div>
  );
}

export default ThemeSettings;
